import axios from "axios";
import { serverURL } from "../../constants/constants";

// Import necessary calls from other files
import {
  errorResponse,
  successResponse,
  toggleWifiDialog,
} from "../../actions";

export function fetchServerVersion() {
  return function (dispatch) {
    console.log("GET request made for /server_version/");
    return axios.get(serverURL + "/server_version").then(
      (response) => {
        dispatch(setServerVersion(response.data["version"]));
      },
      (error) => {}
    );
  };
}
export const SET_SERVER_VERSION = "SET_SERVER_VERSION";
export function setServerVersion(serverVersion) {
  return {
    type: SET_SERVER_VERSION,
    serverVersion,
  };
}

export const SET_AVAILABLE_DRIVES = "SET_AVAILABLE_DRIVES";
export function setAvailableDrives(usbDrives) {
  return {
    type: SET_AVAILABLE_DRIVES,
    usbDrives,
  };
}

export function fetchGetAvailableDrives() {
  return function (dispatch) {
    console.log("GET request made for /get_available_drives/");

    // return axios.get(serverURL + "/get_available_drives").then(
    //   (response) => {
    dispatch(setAvailableDrives({}));
    //   },
    //   (error) => {
    //     dispatch(errorResponse(error));
    //   }
    // );
  };
}

export const REQUEST_CHECK_WIFI = "REQUEST_CHECK_WIFI";
export function requestCheckWifi() {
  return {
    type: REQUEST_CHECK_WIFI,
  };
}

export const RECEIVE_CHECK_WIFI = "RECEIVE_CHECK_WIFI";
export function receiveCheckWifi(availableNetworks, wifiConnection) {
  return {
    type: RECEIVE_CHECK_WIFI,
    availableNetworks,
    wifiConnection,
  };
}

export const RESET_CHECK_WIFI = "RESET_CHECK_WIFI";
export function resetCheckWifi() {
  return {
    type: RESET_CHECK_WIFI,
  };
}

export function fetchCheckWifi(get_network, wifi_turn_on) {
  return function (dispatch) {
    dispatch(requestCheckWifi());

    let req = {
      get_network: get_network,
      wifi_turn_on: wifi_turn_on,
    };
    console.log("POST request made for /check_wifi", req);
    // return axios.post(serverURL + "/check_wifi", req).then(
    //   (response) => {
    dispatch(receiveCheckWifi([], ""));
    // },
    //   (error) => {
    //     dispatch(errorResponse(error));
    //     dispatch(resetCheckWifi());
    //   }
    // );
  };
}

export const RECEIVE_WIFI_CONNECTION = "RECEIVE_WIFI_CONNECTION";
export function receiveWifiConnection(wifiConnection) {
  return {
    type: RECEIVE_WIFI_CONNECTION,
    wifiConnection,
  };
}

export const REQUEST_WIFI_CONNECTION = "REQUEST_WIFI_CONNECTION";
export function requestWifiConnection() {
  return {
    type: REQUEST_WIFI_CONNECTION,
  };
}

export const RESET_WIFI_CONNECTION = "RESET_WIFI_CONNECTION";
export function resetWifiConnection() {
  return {
    type: RESET_WIFI_CONNECTION,
  };
}

export function fetchConnectWifi(wifi, network_id, network_password) {
  return function (dispatch, getState) {
    let req = {
      wifi: wifi,
      network_id: network_id,
      network_password: network_password,
    };
    console.log("POST request made for /connect_wifi", req);
    dispatch(requestWifiConnection());
    // return axios.post(serverURL + "/connect_wifi", req).then(
    //   (response) => {
    //     dispatch(receiveWifiConnection(response.data["network_id"]));
    //     if (wifi) {
    //       dispatch(
    //         successResponse("Connected to " + response.data["network_id"])
    //       );
    //     } else {
    //       dispatch(successResponse("Wifi disconnected."));
    //     }

    //     if (getState().utility.dialog.wifiDialog) {
    //       dispatch(toggleWifiDialog());
    //     }
    //   },
    //   (error) => {
    if (getState().utility.dialog.wifiDialog) {
      dispatch(toggleWifiDialog());
    }
    dispatch(resetWifiConnection());
    // dispatch(errorResponse(error));
    //     }
    //   );
  };
}
